import { AppState } from 'redux/store/types';
import { AuthState } from './types';

export const getAuth = (state: AppState): AuthState => state.auth;
